import React from "react";
import Form from "react-bootstrap/Form";
import { NO_IMG } from "../../../assets/images/images";
import { HistoryProduct as Product } from "../../../modals/Product";
import { isValidImageUrl } from "../../../utils/common";

//for add to cart
import ListingWidget from "../../AddToCartForm/ListingWidget";

import { BIN } from "../../../assets/images/svgImage";

interface ParentProps {
  loadItem: Function;
  removeProduct: Function;
}

const HistoryProduct: React.FC<Product & ParentProps> = ({
  product_image,
  product_name,
  product_id,
  amount,
  loadItem,
  removeProduct,
  out_of_stock,
  product_model,
  allergen_images,
  description,
  rw_price,
  is_cut_off_time_completed
}) => {
  return (
    <div className="product-list-item">
      <i className="product-list-item-img">
        <img
          onError={(e) => {
            const target = e.target as HTMLImageElement;
            target.src = NO_IMG;
          }}
          src={isValidImageUrl(product_image) ? product_image : NO_IMG}
          alt={product_image}
        />
      </i>
      <div className="product-list-item-detail">
        <div className="product-list-detail">
          <div>
            <div
              className="label-action"
              onClick={() => {
                loadItem();
              }}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  loadItem();
                }
              }}
            >
              {product_model && (
                <p className="product-model">Product Code: {product_model}</p>
              )}
              <span>
                {product_name}
                <button
                  type="button"
                  style={{
                    background: "none",
                    border: "none",
                    padding: 0,
                    marginLeft: "10px",
                    cursor: "pointer"
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (globalThis.confirm("Are you sure you want to remove this product from history?")) {
                      removeProduct();
                    }
                  }}
                  title="Remove Item"
                >
                  <img
                    src={BIN}
                    alt="Remove"
                    style={{
                      width: "20px",
                      height: "20px",
                    }}
                  />
                </button>
              </span>
            </div>
            {allergen_images.length > 0 && (
              <div className="d-flex align-items-center flex-wrap mb-3 gap-1">
                {allergen_images.map((icon, index) => ( 
                    <img
                      key={`allergen-${product_id}-${index}`}
                      src={icon}
                      alt={`allergen-${index}`}
                      onError={(e) => (e.currentTarget.src = NO_IMG)}
                      className="img-fluid rounded mr-2"
                      style={{ width: "30px", height: "30px", objectFit: "contain" }}
                    />
                  )
                )}
              </div>
            )}
            <div className="d-flex">
              <span>$ {amount} {(product_name.toLowerCase().startsWith("rw") || description.toLowerCase().startsWith("rw")) && "/ 1 Kg"} </span>
              {rw_price && <span className="rw_price ml-4">est. ${rw_price} Pack</span>}
            </div>
          </div>
          <Form.Group className="ml-md-auto form-group">
            <ListingWidget
              id={product_id}
              is_saved={0}
              isListing
              out_of_stock={out_of_stock}
            />
          </Form.Group>
        </div>
        {is_cut_off_time_completed && <p className="cutoff-time-message">Today's order cutoff has passed, earliest delivery time is the day after tomorrow</p>}
      </div>
    </div>
  );
};

export default HistoryProduct;
